module.exports = __webpack_public_path__ + "img/sld_inverter_red_t1_dark.6fe71ce0.svg";